module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parameters":"Parameters","priority":"Priority","target":"Target"},"de":{"parameters":"Parameter","protocol":"Protokoll","priority":"Priorität","target":"Ziel"}}')
  delete Component.options._Ctor
}
